<template>
    <v-dialog v-model="dialog" max-width="700">
        <time-sheet-class-diary
            v-if="dialog"
            embedded
            :title="title"
            @close="dialog = false"
            @open-timesheet="dialog = false; $emit('open-timesheet')"
        />
    </v-dialog>
</template>

<script>
import TimeSheetClassDiary from '@/modules/time_sheet/class_diary/pages/Index.vue'

export default {
    name: 'SysTeacherClassDiaryHub',
    components: { TimeSheetClassDiary },
    props: {
        show: { type: Boolean, default: false },
        title: { type: String, default: 'Ocorrências do Ponto' },
    },
    data: () => ({ dialog: false }),
    watch: {
        show(val) { this.dialog = val },
        dialog(val) { this.$emit('update:show', val) },
    },
}
</script>
